// src/pages/PreferencesPage.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import PreferencesWizard from "../components/PreferencesWizard";

export default function PreferencesPage() {
  const navigate = useNavigate();
  return (
     <div style={{ paddingTop: "0px" /* adjust as needed */ }}>
    <PreferencesWizard
      mode="page"
      onSaved={() => navigate("/", { replace: true })}
      onClose={() => navigate(-1)}
    />
    </div>
  );
}
